/* ============================================
   ZIVARA THEME — Main JavaScript
   A modern women's jewellery Shopify theme
   ============================================ */

(function() {
  'use strict';

  /* --- DOM Ready --- */
  function onReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  /* ============================================
     ANNOUNCEMENT BAR
     ============================================ */
  function initAnnouncementBar() {
    var closeBtn = document.querySelector('.announcement-bar__close');
    var bar = document.querySelector('.announcement-bar');

    if (closeBtn && bar) {
      closeBtn.addEventListener('click', function() {
        bar.classList.add('is-hidden');
        sessionStorage.setItem('zivara-announcement-closed', 'true');
      });

      // Check if previously closed in this session
      if (sessionStorage.getItem('zivara-announcement-closed') === 'true') {
        bar.classList.add('is-hidden');
      }
    }
  }

  /* ============================================
     MOBILE MENU
     ============================================ */
  function initMobileMenu() {
    var toggle = document.querySelector('.header__menu-toggle');
    var menu = document.querySelector('.mobile-menu');
    var backdrop = document.querySelector('.mobile-menu__backdrop');
    var closeBtn = document.querySelector('.mobile-menu__close');
    var body = document.body;

    function openMenu() {
      if (menu) menu.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-visible');
      body.style.overflow = 'hidden';
    }

    function closeMenu() {
      if (menu) menu.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-visible');
      body.style.overflow = '';
    }

    if (toggle) {
      toggle.addEventListener('click', openMenu);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }

    if (backdrop) {
      backdrop.addEventListener('click', closeMenu);
    }

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeMenu();
      }
    });
  }

  /* ============================================
     STICKY HEADER
     ============================================ */
  function initStickyHeader() {
    var header = document.querySelector('[data-sticky-header]');
    if (!header) return;

    var headerHeight = header.offsetHeight;
    var lastScroll = 0;

    window.addEventListener('scroll', function() {
      var currentScroll = window.pageYOffset;

      if (currentScroll > headerHeight) {
        header.classList.add('header--sticky');
      } else {
        header.classList.remove('header--sticky');
      }

      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ============================================
     PRODUCT IMAGE GALLERY
     ============================================ */
  function initProductGallery() {
    var slider = document.getElementById('ProductGallerySlider');
    var mainImage = document.querySelector('.product-gallery__main img') || document.getElementById('ProductMainImage');
    var thumbs = document.querySelectorAll('.product-gallery__thumb');

    if (!mainImage && !slider) return;
    if (thumbs.length === 0) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var index = parseInt(this.getAttribute('data-image-index'), 10);
        if (isNaN(index)) {
          var newSrc = this.getAttribute('data-full-src') || this.querySelector('img').src;
          if (mainImage) mainImage.src = newSrc;
        }

        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
      });
    });

    if (thumbs[0]) {
      thumbs[0].classList.add('is-active');
    }
  }

  /* ============================================
     PRODUCT CARD MOBILE SWIPE
     ============================================ */
  function initProductCardSwipe() {
    var cards = document.querySelectorAll('.product-card');
    cards.forEach(function(card) {
      var wrapper = card.querySelector('.product-card__image-wrapper');
      var hoverImg = card.querySelector('.product-card__image--hover');
      if (!wrapper || !hoverImg) return;

      var startX = 0;
      var startY = 0;

      wrapper.addEventListener('touchstart', function(e) {
        if (e.touches.length > 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      wrapper.addEventListener('touchend', function(e) {
        if (!startX || !startY) return;
        var diffX = e.changedTouches[0].clientX - startX;
        var diffY = e.changedTouches[0].clientY - startY;

        if (Math.abs(diffX) > 35 && Math.abs(diffX) > Math.abs(diffY)) {
          if (diffX < 0) {
            card.classList.add('is-swiped');
          } else {
            card.classList.remove('is-swiped');
          }
        }
        startX = 0;
        startY = 0;
      }, { passive: true });
    });
  }

  /* ============================================
     QUANTITY SELECTOR
     ============================================ */
  function initQuantitySelectors() {
    var selectors = document.querySelectorAll('.product-quantity__wrapper, .cart-item__quantity');

    selectors.forEach(function(selector) {
      var minusBtn = selector.querySelector('[data-qty-minus]');
      var plusBtn = selector.querySelector('[data-qty-plus]');
      var input = selector.querySelector('input[type="number"]');

      if (!minusBtn || !plusBtn || !input) return;

      minusBtn.addEventListener('click', function() {
        var currentVal = parseInt(input.value) || 1;
        if (currentVal > 1) {
          input.value = currentVal - 1;
          input.dispatchEvent(new Event('change'));
        }
      });

      plusBtn.addEventListener('click', function() {
        var currentVal = parseInt(input.value) || 1;
        var max = parseInt(input.getAttribute('max')) || 99;
        if (currentVal < max) {
          input.value = currentVal + 1;
          input.dispatchEvent(new Event('change'));
        }
      });

      // Validate input on change
      input.addEventListener('change', function() {
        var val = parseInt(this.value) || 1;
        var min = parseInt(this.getAttribute('min')) || 1;
        var max = parseInt(this.getAttribute('max')) || 99;

        if (val < min) this.value = min;
        if (val > max) this.value = max;
      });
    });
  }

  /* ============================================
     VARIANT SELECTOR (Product Page)
     ============================================ */
  function initVariantSelector() {
    var options = document.querySelectorAll('.product-variants__option');
    var variantInput = document.querySelector('input[name="id"]');

    if (options.length === 0) return;

    options.forEach(function(option) {
      option.addEventListener('click', function() {
        var group = this.closest('.product-variants__options');
        if (group) {
          group.querySelectorAll('.product-variants__option').forEach(function(opt) {
            opt.classList.remove('is-selected');
          });
        }
        this.classList.add('is-selected');

        // Update hidden variant ID input
        var variantId = this.getAttribute('data-variant-id');
        if (variantInput && variantId) {
          variantInput.value = variantId;
        }

        // Update price if data provided
        var price = this.getAttribute('data-price');
        var comparePrice = this.getAttribute('data-compare-price');
        updateProductPrice(price, comparePrice);
      });
    });
  }

  function updateProductPrice(price, comparePrice) {
    var priceEl = document.querySelector('.product-info__price');
    var comparePriceEl = document.querySelector('.product-info__compare-price');
    var discountEl = document.querySelector('.product-info__discount-badge');

    if (priceEl && price) {
      priceEl.textContent = price;
    }

    if (comparePriceEl && comparePrice) {
      comparePriceEl.textContent = comparePrice;
      comparePriceEl.style.display = comparePrice ? '' : 'none';
    }

    if (discountEl && price && comparePrice) {
      var priceNum = parseFloat(price.replace(/[^\d.]/g, ''));
      var comparePriceNum = parseFloat(comparePrice.replace(/[^\d.]/g, ''));
      if (comparePriceNum > priceNum) {
        var discount = Math.round(((comparePriceNum - priceNum) / comparePriceNum) * 100);
        discountEl.textContent = 'Save ' + discount + '%';
        discountEl.style.display = '';
      } else {
        discountEl.style.display = 'none';
      }
    }
  }

  /* ============================================
     PRODUCT ACCORDION
     ============================================ */
  function initAccordion() {
    var triggers = document.querySelectorAll('.product-accordion__trigger');

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var item = this.closest('.product-accordion__item');
        if (item) {
          item.classList.toggle('is-open');
        }
      });
    });

    // Open first accordion item by default
    var firstItem = document.querySelector('.product-accordion__item');
    if (firstItem) {
      firstItem.classList.add('is-open');
    }
  }

  /* ============================================
     CART DRAWER (AJAX)
     ============================================ */
  function initCartDrawer() {
    // Add to Cart forms
    var addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

    addToCartForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        // Let Shopify handle the form normally if JS is not needed
        // This can be enhanced for AJAX add-to-cart
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
          var originalText = submitBtn.textContent;
          submitBtn.textContent = 'Adding...';
          submitBtn.disabled = true;

          setTimeout(function() {
            submitBtn.textContent = 'Added! ✓';
            setTimeout(function() {
              submitBtn.textContent = originalText;
              submitBtn.disabled = false;
            }, 1500);
          }, 500);
        }
      });
    });
  }

  /* ============================================
     QUICK ADD TO CART (Product Cards)
     ============================================ */
  function initQuickAdd() {
    var quickAddButtons = document.querySelectorAll('.product-card__quick-add');

    quickAddButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = this.getAttribute('data-variant-id');
        if (!variantId) return;

        var originalText = this.textContent;
        this.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          btn.textContent = 'Added! ✓';
          updateCartCount();
          setTimeout(function() {
            btn.textContent = originalText;
          }, 2000);
        })
        .catch(function(error) {
          btn.textContent = 'Error';
          setTimeout(function() {
            btn.textContent = originalText;
          }, 2000);
        });
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var countEls = document.querySelectorAll('.header__cart-count');
        countEls.forEach(function(el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.style.display = 'flex';
          }
        });
      })
      .catch(function() {});
  }

  /* ============================================
     LAZY LOADING IMAGES
     ============================================ */
  function initLazyLoading() {
    // Use native lazy loading — already in HTML with loading="lazy"
    // Fallback for older browsers using IntersectionObserver
    if ('IntersectionObserver' in window) {
      var lazyImages = document.querySelectorAll('img[data-src]');

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            img.src = img.getAttribute('data-src');
            if (img.getAttribute('data-srcset')) {
              img.srcset = img.getAttribute('data-srcset');
            }
            img.removeAttribute('data-src');
            img.removeAttribute('data-srcset');
            observer.unobserve(img);
          }
        });
      }, {
        rootMargin: '200px 0px'
      });

      lazyImages.forEach(function(img) {
        observer.observe(img);
      });
    }
  }

  /* ============================================
     SMOOTH SCROLL
     ============================================ */
  function initSmoothScroll() {
    var anchors = document.querySelectorAll('a[href^="#"]');

    anchors.forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#') return;

        var targetEl = document.querySelector(targetId);
        if (targetEl) {
          e.preventDefault();
          var headerOffset = 80;
          var elementPosition = targetEl.getBoundingClientRect().top;
          var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  /* ============================================
     NEWSLETTER FORM
     ============================================ */
  function initNewsletter() {
    var forms = document.querySelectorAll('.newsletter__form');

    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        var emailInput = form.querySelector('input[type="email"]');
        var messageEl = form.closest('.newsletter').querySelector('.newsletter__message');

        if (emailInput && emailInput.value.trim() === '') {
          e.preventDefault();
          if (messageEl) {
            messageEl.textContent = 'Please enter a valid email address.';
            messageEl.className = 'newsletter__message newsletter__message--error';
          }
          return;
        }

        // Show success on submit (Shopify handles the actual subscription)
        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) {
          submitBtn.textContent = 'Subscribing...';
          submitBtn.disabled = true;
        }
      });

      // Check URL for newsletter success
      if (window.location.hash === '#newsletter' && window.location.search.includes('customer_posted=true')) {
        var messageEl = form.closest('.newsletter').querySelector('.newsletter__message');
        if (messageEl) {
          messageEl.textContent = 'Thank you for subscribing! 🎉';
          messageEl.className = 'newsletter__message newsletter__message--success';
        }
      }
    });
  }

  /* ============================================
     COLLECTION PAGE — SORT BY
     ============================================ */
  function initCollectionSort() {
    var sortSelect = document.querySelector('.collection-sort__select');

    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }
  }

  /* ============================================
     CART PAGE — UPDATE QUANTITIES
     ============================================ */
  function initCartUpdates() {
    var cartItems = document.querySelectorAll('.cart-item__quantity');

    cartItems.forEach(function(item) {
      var input = item.querySelector('input');
      if (!input) return;

      input.addEventListener('change', function() {
        var lineIndex = this.getAttribute('data-line');
        var quantity = parseInt(this.value) || 0;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: parseInt(lineIndex),
            quantity: quantity
          })
        })
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          // Reload page to reflect changes
          window.location.reload();
        })
        .catch(function(error) {
          console.error('Cart update error:', error);
        });
      });
    });

    // Remove item buttons
    var removeButtons = document.querySelectorAll('.cart-item__remove');

    removeButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var lineIndex = this.getAttribute('data-line');

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: parseInt(lineIndex),
            quantity: 0
          })
        })
        .then(function() {
          window.location.reload();
        })
        .catch(function(error) {
          console.error('Cart remove error:', error);
        });
      });
    });
  }

  /* ============================================
     PINCODE CHECKER
     ============================================ */
  function initPincodeChecker() {
    var form = document.querySelector('.pincode-checker__form');

    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var input = form.querySelector('.pincode-checker__input');
        var resultEl = form.querySelector('.pincode-checker__result') || document.createElement('div');

        if (!resultEl.classList.contains('pincode-checker__result')) {
          resultEl.className = 'pincode-checker__result';
          form.after(resultEl);
        }

        var pincode = input ? input.value.trim() : '';

        if (pincode.length !== 6 || isNaN(pincode)) {
          resultEl.innerHTML = '<span style="color: var(--color-error); font-size: 0.875rem;">Please enter a valid 6-digit pincode.</span>';
          return;
        }

        resultEl.innerHTML = '<span style="color: var(--color-text-secondary); font-size: 0.875rem;">Checking delivery to ' + pincode + '...</span>';

        // Simulate pincode check (replace with actual API in production)
        setTimeout(function() {
          resultEl.innerHTML = '<span style="color: var(--color-success); font-size: 0.875rem;">✓ Delivery available to ' + pincode + '. Expected in 3-7 business days.</span>';
        }, 1000);
      });
    }
  }

  /* ============================================
     SEARCH TOGGLE
     ============================================ */
  function initSearchToggle() {
    var searchToggle = document.querySelector('[data-search-toggle]');
    var searchOverlay = document.querySelector('.search-overlay');
    var searchClose = document.querySelector('.search-overlay__close');
    var searchInput = document.querySelector('.search-overlay__input');

    if (searchToggle && searchOverlay) {
      searchToggle.addEventListener('click', function(e) {
        e.preventDefault();
        searchOverlay.classList.add('is-open');
        if (searchInput) searchInput.focus();
        document.body.style.overflow = 'hidden';
      });
    }

    if (searchClose && searchOverlay) {
      searchClose.addEventListener('click', function() {
        searchOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }

    // Close search on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('is-open')) {
        searchOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ============================================
     SCROLL ANIMATIONS
     ============================================ */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) return;

    var animatedElements = document.querySelectorAll('[data-animate]');

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    animatedElements.forEach(function(el) {
      el.style.opacity = '0';
      observer.observe(el);
    });
  }

  /* ============================================
     INITIALIZE ALL MODULES
     ============================================ */
  onReady(function() {
    initAnnouncementBar();
    initMobileMenu();
    initStickyHeader();
    initProductGallery();
    initQuantitySelectors();
    initVariantSelector();
    initAccordion();
    initCartDrawer();
    initQuickAdd();
    initLazyLoading();
    initSmoothScroll();
    initNewsletter();
    initCollectionSort();
    initCartUpdates();
    initPincodeChecker();
    initSearchToggle();
    initScrollAnimations();
    initProductCardSwipe();
  });

})();
